import { createSlice, PayloadAction } from "@reduxjs/toolkit";



const initialState:  number = 0; 

const productSlice = createSlice({
    name: 'productsCount',
    initialState,
    reducers: {
      setTotalProductsCount(state, action: PayloadAction<number>) {
        return action.payload;
      },

      resetTotalProductsCount() {
        return initialState
      },
    },     
});

export const {setTotalProductsCount, resetTotalProductsCount} = productSlice.actions;
export default productSlice.reducer;